import { render } from "./Spolek.vue?vue&type=template&id=4287df94"
import script from "./Spolek.vue?vue&type=script&lang=js"
export * from "./Spolek.vue?vue&type=script&lang=js"
script.render = render

export default script